import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store';

import vuetify from './plugins/vuetify';

import {component, options} from './plugins/vue2-google-maps'
Vue.use(component, options);

import VCalendar from 'v-calendar';
Vue.use(VCalendar, {componentPrefix: 'im'});

import moment from 'moment';
Vue.prototype.$moment = moment;

import lodash from 'lodash';

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
